import React, { useEffect, useRef, useState } from 'react'
import styles from './Header.module.scss'
import Svg from '../Svg'
import { Popover } from 'antd'
import routes from '../../utils/router'
import { PILGRIMAGE, PILGRIMAGE_ONLINE } from '../../utils/constants'
import './header.scss'
import InlineProfileMenu from './InlineProfileMenu'

function Header({ business }) {
  const descriptionLinks = routes().links.map((i, index) => ({
    ...i,
    svg: i.name,
    id: index
  }))

  const logo = business?.logo
  const isBimeh = business?.isBimeh
  const BranchWithShowType = business?.BranchWithShowType;

  const walletRef = useRef(true)
  const firstRender = useRef(true)
  const [, setUserInfo] = useState({})
  const [, setIsLoggedIn] = useState('')
  const [visibleBranches, setVisibleBranches] = useState(true)
  const [visibleLogged, setVisibleLogged] = useState(false)
  const [visibleQuestion, setVisibleQuestion] = useState(false)
  const [showArrow, setShowArrow] = useState(null)

  const [, setUserToken] = useState('')
  const [mobileMenuProfileDrawer, setMobileMenuProfileDrawer] = useState(false)

  useEffect(() => {
    if (localStorage && localStorage.getItem('app-store')) {
      const store = JSON.parse(localStorage.getItem('app-store'))
      if (store) {
        setUserInfo(store?.state?.user?.info?.data)
        setIsLoggedIn(store?.state?.auth?.userToken)
        setUserToken(store?.state?.auth?.userToken)
      }
    }
  }, [])

  let branches = []
  BranchWithShowType?.map(item => {
    let rec = routes().links.filter(link => {
      return item.Branch === link?.name
    })[0]
    const desc = descriptionLinks.filter(item => item.name === rec?.name)[0]
    if (desc) {
      if (
        branches?.filter(
          link => link.name === PILGRIMAGE || link.name === PILGRIMAGE_ONLINE
        )[0] &&
        (desc.name === PILGRIMAGE || desc.name === PILGRIMAGE_ONLINE)
      )
        return
      else branches.push(desc)
    }
  })

  useEffect(() => {
    setVisibleBranches(false)
  }, [])

  function visibleHandler() {
    if (firstRender.current) {
      firstRender.current = false
    }
    setVisibleBranches(!visibleBranches)
  }

  function visibleQuestionHandler() {
    setVisibleQuestion(!visibleQuestion)
  }

  useEffect(() => {
    if (visibleLogged && walletRef.current) {
      walletRef.current = false
    }
  }, [visibleLogged])

  return (
    <div className={styles.header}>

      <header className={`${"header-responsive"} header-responsive d-flex d-lg-none header-bk-color `}>
        <div className="container d-flex justify-content-between align-items-center" style={{ width: "100%", padding: "0" }}>
          <div className={'hamburger'} onClick={() => setMobileMenuProfileDrawer(!mobileMenuProfileDrawer)} data-tracking-id="hamburger-menu-"><Svg name="menu-burger" className="fill-header-color" /></div>
          <div>
            <a href="https://bimeh.com/" target="_blank">
              <img
                width="150"
                height="23"
                src={logo}
                alt="بیمه دات کام" />
            </a>
          </div>
          <a href='https://bimeh.com/contact' className='d-flex align-items-center'>
            <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none">
              <path d="M23.5 0.5H15C6.99187 0.5 0.5 6.99187 0.5 15V23.5C0.5 31.5081 6.99187 38 15 38H23.5C31.5081 38 38 31.5081 38 23.5V15C38 6.99187 31.5081 0.5 23.5 0.5Z" stroke="#E3E4E5" />
              <path d="M16.144 12H13.318C12.9684 12 12.6332 12.1389 12.386 12.386C12.1389 12.6332 12 12.9684 12 13.318C12 16.8141 13.3888 20.167 15.8609 22.6391C18.333 25.1112 21.6859 26.5 25.182 26.5C25.5316 26.5 25.8668 26.3611 26.114 26.114C26.3611 25.8668 26.5 25.5316 26.5 25.182V22.357L23.393 20.286L21.782 21.897C21.6495 22.0357 21.4762 22.1284 21.2873 22.1617C21.0985 22.195 20.9039 22.1671 20.732 22.082C19.813 21.6026 18.9658 20.9967 18.215 20.282C17.4545 19.5525 16.8325 18.6912 16.379 17.74C16.3042 17.5732 16.2833 17.3873 16.3192 17.208C16.355 17.0288 16.4458 16.8652 16.579 16.74L18.217 15.102L16.144 12Z" stroke="#666666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </a>
        </div>
        <InlineProfileMenu
          setMobileMenuProfileDrawer={setMobileMenuProfileDrawer}
          mobileMenuProfileDrawer={mobileMenuProfileDrawer}
        />
        {/* <InlineMainMenu toggleMobileMenu={toggleMobileMenu} mobileMenuDrawer={mobileMenuDrawer} /> */}
        {/* <InlineProfileMenu  toggleMobileProfileMenu={toggleMobileProfileMenu} mobileMenuProfileDrawer={mobileMenuProfileDrawer} /> */}

      </header >
      <header className='header-new d-none d-lg-block header-bk-color'>
        <nav className='container'>
          <div className='header__container header-bk-color'>
            <div className='d-flex align-items-center'>
              <div className='col-auto'>
                <a href={window.location.origin} className='brand'>
                  <img
                    alt='بیمه دات کام'
                    width='180'
                    height='25'
                    src={business?.logo}
                  />
                </a>
              </div>
              <div className='header__items__container mb-0 mt-0 pr-0'>
                <div className='header__items__container__line header-color'>
                  |
                </div>
                <div
                  onClick={visibleHandler}
                  // onMouseEnter={() => setVisible(true)}
                  // onMouseLeave={() => setVisible(false)}
                  className={`col-auto d-flex align-items-center header-color`}
                >
                  <Popover
                    showArrow={false}
                    zIndex={firstRender.current ? -2 : 1000}
                    trigger='click'
                    align={{ targetOffset: [290, 0] }}
                    onOpenChange={visibleHandler}
                    open={visibleBranches}
                    overlayClassName={
                      isBimeh
                        ? `header-guides-popover`
                        : 'header-guides-popover-wl'
                    }
                    className='header-menu-product-text'
                    content={
                      <div className='content__container'>
                        {branches?.map((link, index) => (
                          <a
                            onMouseEnter={() => setShowArrow(link.id)}
                            onMouseLeave={() => setShowArrow(null)}
                            data-tracking-id='main-menu-categories'
                            onClick={() => {
                              setVisibleBranches(!visibleBranches)
                            }}
                            key={index}
                            href={window.location.origin + link.path}
                            className='header__item d-flex'
                          >
                            <div className='svg__container ins-icon bimehheader-menu'>
                              <Svg name={link.svg} />
                            </div>
                            <div className='header__item__container d-flex flex-column align-items-start pr-1'>
                              <div className='header__item__title'>
                                {link.insuranceFaName}
                              </div>
                              <div className='header__item__description'>
                                {link.description}
                              </div>
                            </div>
                            {showArrow === link.id && (
                              // true &&

                              <div className={styles['arrow__container']}>
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlnssvgjs="http://svgjs.com/svgjs" version="1.1" width="22" height="22" x="0" y="0" viewBox="0 0 24 24" style={{ enableBackground: "new 0 0 512 512" }} xmlSpace="preserve"><g><path xmlns="http://www.w3.org/2000/svg" d="M19,10.5H10.207l2.439-2.439a1.5,1.5,0,0,0-2.121-2.122L6.939,9.525a3.505,3.505,0,0,0,0,4.95l3.586,3.586a1.5,1.5,0,0,0,2.121-2.122L10.207,13.5H19a1.5,1.5,0,0,0,0-3Z" className={styles["fill-secondary-color"]} data-original="#000000" /></g></svg>
                              </div>

                            )}
                          </a>
                        ))}
                      </div>
                    }
                  >
                    <span className='header-color'>بیمه‌ها</span>
                    <Svg
                      name='flash-small-down'
                      className={`pr-1 font-size-6 ${visibleBranches
                        ? 'rotate-180 flash-small-down'
                        : 'rotate-0'
                        } `}
                    />
                  </Popover>
                </div>
                <div className='col-auto'>
                  <a
                    target='_blank'
                    href='https://bimeh.com/companies/'
                    className='header-color btn-mag'
                    data-tracking-id='insurance-blog'
                  >
                    {' '}
                    شرکت‌های بیمه{' '}
                  </a>
                </div>
                <div className='col-auto'>
                  <a
                    target='_blank'
                    className='primary-color btn-marketers'
                    style={{ fontWeight: 550 }}
                    href='https://bimeh.com/marketers/'
                  >
                    کسب درآمد کنید
                    <span>!</span>
                  </a>
                </div>
              </div>
            </div>

            <div className='header__items__container'>
              <div onClick={visibleQuestionHandler}>
                <Popover
                  align={{ targetOffset: [0, -12] }}
                  showArrow={false}
                  onOpenChange={visibleQuestionHandler}
                  trigger='click'
                  open={visibleQuestion}
                  className='header-menu-product-text'
                  overlayClassName='header-question-popover'
                  placement='bottomRight'
                  content={
                    <div className='header__loggedin__popover'>
                      <>
                        {business?.phone && (
                          <a
                            data-tracking-id='phone-number-connect'
                            href={`tel:${business.phone}`}
                            className='header__loggedin__popover__item1'
                          >
                            <div className='d-flex align-items-center ml-auto'>
                              <div className='icon'>
                                <Svg
                                  name='phone-call'
                                  className='fill-light-surface-color'
                                />
                              </div>
                              <a href={`tel:${business.phone}`}>
                                مشاوره و پشتیبانی
                              </a>
                            </div>
                            <div>
                              <span className='d-none unfinished-purchase'>
                                {/* {userInfo && StringHelper.getFarsiNum(userInfo.NumberOfUnfinishedPurchases)} */}
                              </span>
                            </div>
                          </a>
                        )}
                        <div className='header__loggedin__popover__item1'>
                          <div className='icon'>
                            <Svg name='question-square' />
                          </div>
                          <a
                            to={window.location.origin + '/faq'}
                            data-tracking-id='frequently-asked-questions'
                          >
                            سوالات متداول
                          </a>
                        </div>

                        <div className='header__loggedin__popover__responsibility'>
                          <div className='main'>24 ساعته پاسخگوی شماییم</div>
                        </div>
                      </>
                    </div>
                  }
                >
                  <div
                    className={`col-auto d-flex align-items-center p-0 ${visibleQuestion ? 'header-color' : 'header-color'
                      }`}
                  >
                    سوالی دارید؟
                    <Svg
                      name='flash-small-down'
                      className={`pr-1 font-size-6 ${visibleQuestion
                        ? 'rotate-180 flash-small-down'
                        : 'rotate-0'
                        }`}
                    />
                  </div>
                </Popover>
              </div>

              <div
                onClick={() =>
                  window.location.replace(
                    window.location.origin + '/TrackingRequest'
                  )
                }
                className='col-auto'
                data-tracking-id='track-order'
              >
                <div className='header-color' data-tracking-id='track-order'>
                  پیگیری خرید
                </div>
              </div>
            </div>
          </div>
        </nav>
        <div className='down-side-line' />
      </header>
    </div>
  )
}

export default Header
